import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Riders from '../components/Riders';
import Sponsors from '../components/Sponsors';
import Footer from '../components/Footer';
import { teamData, riders, sponsors, socialMedia } from '../data/mock';

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header logo={teamData.logo} />
      <Hero 
        videoUrl={teamData.video} 
        posterUrl={teamData.poster}
        videoMobileUrl={teamData.videoMobile}
        posterMobileUrl={teamData.posterMobile}
        teamName={teamData.name}
        logo={teamData.logo}
      />
      <About teamData={teamData} />
      <Riders riders={riders} />
      <div id="partner">
        <Sponsors sponsors={sponsors} />
      </div>
      <Footer 
        socialMedia={socialMedia} 
        teamName={teamData.name}
        logo={teamData.logo}
      />
    </div>
  );
};

export default Home;
